module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av296-a317cac01c6d536dfad5f7517522d54f.jpg";